import React from 'react';
import { reminderHelpers } from './reminder-helpers';
import { FluentTime } from "../../../../../../components/FluentUI/Fluent-Time";
import { getTimeFromTimeStamp } from '../../../../../../util/time-helpers';
import PropTypes from 'prop-types';

export const ReminderName = ({ taskReminder, setTaskReminder }) => {
    return (
        <React.Fragment>
            <div
                className="elements-container elements-container-no-margin show">
                <div className="durationLabel">
                    <span>Reminder Name (optional)</span>
                </div>
            </div>
            <div
                className="reminder-name-container elements-container show">
                <div className="non-custom-reminder-name">
                    <input
                        id="reminderName"
                        data-testid="reminderName"
                        name="reminderName"
                        value={taskReminder?.name}
                        type="text"
                        onChange={(e) => {
                            reminderHelpers.handleChange("name", e.target.value, setTaskReminder);
                        }}
                        disabled={!taskReminder?.exist}
                        placeholder="For example, Follow-up #1, Reminder #1, etc."
                        className="big-element"
                        maxLength={56}
                    />
                    <span>Enter a maximum of 56 characters.</span>
                </div>
            </div>
        </React.Fragment>
    );
}

export const TimeLabel = () => {
    return (
        <div className="elements-container elements-container-no-margin show" data-testid="time-label">
            <div className="durationLabel">
                <span>Reminder Time</span>
            </div>
        </div>
    );
}

export const ReminderTimePicker = ({ taskReminder, setTaskReminder, className }) => {
    return (
        <FluentTime
            className={className}
            data-testid="reminder-time-picker"
            value={taskReminder.time}
            onChange={(value) =>
                reminderHelpers.handleChange("time", value, setTaskReminder)
            }
            timeIntervals={15}
            disabled={!taskReminder.exist}
        />
    )
}

export const ReminderScheduleText = ({ taskReminder }) => {
    return (
        <h4 className="recurrence-details" data-testid="reminder-schedule-text">
            Reminder will be sent
            {taskReminder.reminder.id == 0 && " on due date "}
            {taskReminder.reminder.id == 1 &&
                (taskReminder.reminderRecurring.name === "Custom"
                    ? ` every ${taskReminder.days
                    } ${taskReminder.reminderRecurringIntervalType.name.toLowerCase()} after start date`
                    : ` ${taskReminder.reminderRecurring.name.toLowerCase()}`)}
            {(taskReminder.reminder.id == 2 ||
                taskReminder.reminder.id == 3) &&
                ` ${taskReminder.days
                } days ${taskReminder.reminder.name.toLowerCase()} `}
            {" at " + getTimeFromTimeStamp(taskReminder.time)}
        </h4>
    )
}

ReminderName.propTypes = {
    taskReminder: PropTypes.shape({
        name: PropTypes.string,
        exist: PropTypes.bool,
        time: PropTypes.instanceOf(Date),
    }),
    setTaskReminder: PropTypes.func.isRequired,
};

ReminderTimePicker.propTypes = {
    taskReminder: PropTypes.shape({
        name: PropTypes.string,
        exist: PropTypes.bool,
        time: PropTypes.instanceOf(Date),
    }),
    setTaskReminder: PropTypes.func.isRequired,
    className: PropTypes.string,
};

ReminderScheduleText.propTypes = {
    taskReminder: PropTypes.shape({
        reminder: PropTypes.shape({
            id: PropTypes.number,
            name : PropTypes.string,
        }),
        reminderRecurring: PropTypes.shape({
            name: PropTypes.string,
        }),
        reminderRecurringIntervalType: PropTypes.shape({
            name: PropTypes.string,
        }),
        days: PropTypes.number,
        time: PropTypes.instanceOf(Date),
    }),
};